import { render, staticRenderFns } from "./CDSelect.vue?vue&type=template&id=59c4fb37&scoped=true&"
import script from "./CDSelect.vue?vue&type=script&lang=js&"
export * from "./CDSelect.vue?vue&type=script&lang=js&"
import style0 from "./CDSelect.vue?vue&type=style&index=0&id=59c4fb37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c4fb37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDialog,VSelect})
